<template>
  <div>
    <!-- 검색 -->
    <search-nav @handleSearch="handleSearch" class="mb-8">
      <search-nav-year-month label="연도" type="year" yearAfter="" v-model="search.연도" :use-all-year="false" />
      <search-nav-item-select
        label="반기"
        v-model="search.반기"
        :list="[
          { value: 1, text: '상반기/하반기' },
          { value: 2, text: '상반기' },
          { value: 3, text: '하반기' },
        ]"
      />
      <search-nav-item-keyword v-model="keyword" @keyupEvent="handleSearch" />
    </search-nav>

    <!-- 리스트 -->
    <CustomOptionSelector
      :options="[
        { value: 10, text: '10개씩 보기' },
        { value: 20, text: '20개씩 보기' },
        { value: 50, text: '50개씩 보기' },
        { value: 100, text: '100개씩 보기' },
      ]"
      v-model="perPage"
      class="mb-4"
    />

    <table class="list">
      <colgroup>
        <col width="60" />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th>No.</th>
          <th>사업장(사업)명</th>
          <th>이행</th>
          <th>보기</th>
        </tr>
      </thead>
      <tbody v-if="0 < fieldList.length">
        <fragment v-for="(field, _index) in fieldList" :key="`${field.id}`">
          <tr>
            <td>{{ (page - 1) * perPage + _index + 1 }}</td>
            <td>{{ field.field_name }}</td>
            <td>
              <div v-if="loading">-</div>
              <div v-else class="flex" style="align-items: center">
                <div class="circle" :class="checkInspected(field.id) === '이행' ? 'green' : ''"></div>
                {{ checkInspected(field.id) }}
              </div>
            </td>
            <td>
              <div v-if="checkInspected(field.id) === '이행'" class="flex" style="align-items: center; color: #7e72f2; cursor: pointer" @click="clickViewPage(field.id)">
                문서보기
                <feather-icon icon="ChevronRightIcon" style="width: 18px" />
              </div>
            </td>
          </tr>
        </fragment>
      </tbody>
    </table>

    <div class="vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="total" v-model="page" @change="handleChangePage"></k-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";

import SearchNav from "@/components/nav/SearchNav";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemFieldSelect from "@/components/nav/SearchNavItemFieldSelect";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import KPagination from "@/components/kPagination/kPagination";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword.vue";

export default {
  components: {
    SearchNavItemKeyword,
    SearchNav,
    SearchNavYearMonth,
    SearchNavItemSelect,
    SearchNavItemFieldSelect,
    CustomOptionSelector,
    KPagination,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    total() {
      const _total = Math.ceil(this.totalFieldCount / this.perPage);
      return _total < 1 ? 1 : _total;
    },
  },
  data() {
    return {
      showPopup: false,
      loading: false,

      search: {
        연도: { year: new Date().getFullYear(), month: "" },
        반기: "",
      },
      keyword: "",

      page: 1,
      perPage: 10,
      list: [{}],
      summary: {},

      // 사업장 목록
      fieldList: [],
      totalFieldCount: 0,
      apiLastLoadOptions: {},

      // 이행한 사업장 ID 목록
      inspectedFieldIds: [],
    };
  },
  watch: {
    perPage() {
      this.loadFieldList();
    },
  },
  mounted() {
    this.loadFieldList();
  },
  methods: {
    handleSearch() {
      this.page = 1;
      this.loadFieldList();
    },
    handleChangePage(page) {
      this.page = page;
      this.loadFieldList();
    },
    clickViewPage(fieldId) {
      const postId = this.getInspectionPostId(fieldId);
      this.$router.push({ path: `/project/${this.projectId}/tab/1083/write/${postId}` });
    },

    async loadFieldList() {
      const projectId = this.projectId;
      const page = this.page;
      const perPage = this.perPage;
      const keyword = this.keyword;

      this.loading = true;

      const options = { projectId, keyword, page, perPage };
      if (JSON.stringify(options) !== JSON.stringify(this.apiLastLoadOptions)) {
        this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
        const fieldList = await this.$store.dispatch("project/LOAD_FIELD_LIST", options);
        this.fieldList = fieldList.data;

        this.currentPage = fieldList.curent_page;
        this.lastPage = fieldList.last_page;
        this.totalFieldCount = fieldList.total;
      }
      await this.사업장이이행했는지확인();
      this.loading = false;
    },

    /**
     * 사업장이 반기별 보고 이행했는지 확인한다
     * @returns {Promise<void>}
     */
    async 사업장이이행했는지확인() {
      const projectId = this.$route.params.proj_id;
      const boardId = 1083;
      const page = 1;
      const perPage = 1000;
      const dateTarget = "body.stdInfo.점검일";
      const dateBegin = `${this.search.연도.year}-01-01`;
      const dateEnd = `${Number(this.search.연도.year) + 1}-01-01`;

      const fieldIds = this.fieldList.map((field) => field.id);

      // 선택된 년도 내에서 작성된 글을 검색한다
      const conditions = [];
      conditions.push({ key: dateTarget, operator: ">=", value: dateBegin });
      conditions.push({ key: dateTarget, operator: "<", value: dateEnd });
      conditions.push({ key: "body.pobList[%].data1", operator: "IN", value: fieldIds });

      if (this.search.반기 === 2) {
        conditions.push({ key: "body.checked", operator: "=", value: "상반기" });
      }
      if (this.search.반기 === 3) {
        conditions.push({ key: "body.checked", operator: "=", value: "하반기" });
      }

      const postList = await this.$store.dispatch("board/LOAD_POST_LIST", {
        boardId,
        projectId,
        page,
        perPage,
        // keyword,
        conditions,
      });

      const list = postList.data;
      this.inspectedFieldIds = [];
      for (const post of list) {
        const content = JSON.parse(post.post_content) || {};
        const pobList = content.body.pobList || [];
        for (const pob of pobList) {
          if (fieldIds.includes(pob.data1)) {
            this.inspectedFieldIds.push({
              fieldId: pob.data1,
              postId: post.id,
            });
          }
        }
      }
    },

    checkInspected(fieldId) {
      return this.inspectedFieldIds.some((item) => item.fieldId === fieldId) ? "이행" : "미이행";
    },
    getInspectionPostId(fieldId) {
      const item = this.inspectedFieldIds.find((item) => item.fieldId === fieldId);
      return item ? item.postId : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
table.total {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px;
  }

  th,
  td:nth-child(1) {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }

  td {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    background-color: #ffffff;
  }

  tr:last-child td:nth-child(n + 2) {
    background: #fff;
  }
}

table.list {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  background: white;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    background: #fafafa;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    padding: 10px 4px;
    div {
      justify-content: center;
    }
  }
}

.circle:before {
  content: "";
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 8px;
  border-radius: 100%;
  background: #ea5455;
}

.green.circle:before {
  background: #28c76f;
}
</style>
